import { AnalyticEventCategory, AnalyticEventType, ReactivationSequenceAnalytics, ReactivationTypeEnum } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { CustomLinkUtils } from '../../../shared/scripts/ui_utils/CustomLinkUtils.ts';
import { ReferralProgramUtils } from '../../../shared/scripts/referral/ReferralProgramUtils.ts';
export class UIReferralProgramController {
    async initReferralTracking() {
        if (this.referrerId == undefined) return;
        if (this.referralOrReactivationType == undefined) return;
        if (this.referrerId == 'bot') {
            const reactivationType = Number(this.referralOrReactivationType);
            UIReferralProgramController.sendBotReactivationAnalytics(reactivationType);
            return;
        }
        const customLink = this.referralOrReactivationType;
        const referralType = CustomLinkUtils.extractReferralTypeFromCustomLink(customLink);
        void ReferralProgramUtils.setUserReferrer(this.referrerId, undefined, referralType);
    }
    static sendBotReactivationAnalytics(reactivationType) {
        const botShareActivityLinkAnalytics = UIReferralProgramController.getBotShareActivityLinkAnalytics(reactivationType);
        if (botShareActivityLinkAnalytics != undefined) {
            const eventDataBotShareActivityLink = {
                type: AnalyticEventType.ReactivationAnalytics,
                category: AnalyticEventCategory.BotShareActivityLink,
                floatValue: botShareActivityLinkAnalytics
            };
            void CA.sendAnalyticEvent(eventDataBotShareActivityLink);
        }
    }
    static getBotShareActivityLinkAnalytics(reactivationType) {
        switch(reactivationType){
            case ReactivationTypeEnum.Reactivation24HoursAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation24HoursAfterLastActivityLaunch;
            case ReactivationTypeEnum.Reactivation1WeekAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation1WeekAfterLastActivityLaunch;
            case ReactivationTypeEnum.Reactivation1MonthAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation1MonthAfterLastActivityLaunch;
            case ReactivationTypeEnum.Reactivation3MonthsAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation3MonthsAfterLastActivityLaunch;
            case ReactivationTypeEnum.Reactivation6MonthsAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation6MonthsAfterLastActivityLaunch;
            case ReactivationTypeEnum.Reactivation1YearAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation1YearAfterLastActivityLaunch;
            case ReactivationTypeEnum.Reactivation2YearsAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation2YearsAfterLastActivityLaunch;
            default:
                return undefined;
        }
    }
    constructor(referrerId, referralOrReactivationType){
        this.referrerId = referrerId;
        this.referralOrReactivationType = referralOrReactivationType;
    }
}
